import { LabelNames } from '~composables/lobby-games/interface'

export const lobbyGamesPromotionBanner = '/assets/images/components/lobby-games/banner-promotion.png'

export const gameFilterCategory = [
  {
    label: 'Lọc game',
    icon: 'icon-ic-filter',
    value: '',
    loginRequired: false
  },
  {
    label: 'Mới nhất',
    value: LabelNames.NEW,
    icon: '',
    loginRequired: false
  }
]
